"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DEFAULT_LANG", {
  enumerable: true,
  get: function () {
    return _utils.DEFAULT_LANG;
  }
});
Object.defineProperty(exports, "DEFAULT_MARKET", {
  enumerable: true,
  get: function () {
    return _utils.DEFAULT_MARKET;
  }
});
Object.defineProperty(exports, "GlobalizationProvider", {
  enumerable: true,
  get: function () {
    return _provider.GlobalizationProvider;
  }
});
Object.defineProperty(exports, "currentCountry", {
  enumerable: true,
  get: function () {
    return _utils.currentCountry;
  }
});
Object.defineProperty(exports, "currentLang", {
  enumerable: true,
  get: function () {
    return _utils.currentLang;
  }
});
Object.defineProperty(exports, "getLocalizedDayjs", {
  enumerable: true,
  get: function () {
    return _utils.getLocalizedDayjs;
  }
});
Object.defineProperty(exports, "globalizationPath", {
  enumerable: true,
  get: function () {
    return _utils.globalizationPath;
  }
});
Object.defineProperty(exports, "renderContent", {
  enumerable: true,
  get: function () {
    return _provider.renderContent;
  }
});
Object.defineProperty(exports, "setMarketCookies", {
  enumerable: true,
  get: function () {
    return _utils.setMarketCookies;
  }
});
Object.defineProperty(exports, "useGlobal", {
  enumerable: true,
  get: function () {
    return _provider.useGlobal;
  }
});
var _utils = require("./utils");
var _provider = require("./provider");